// extracted by mini-css-extract-plugin
module.exports = {"root":"modal-header_root__8YdG9","container":"modal-header_container__4GU2T"};